/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PublishedInputs */

const sv_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicerad`)
};

const en_published = /** @type {(inputs: PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {PublishedInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const published = /** @type {((inputs?: PublishedInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PublishedInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_published(inputs)
	return en_published(inputs)
});